const initialDetails = [
    {
      id: 1,
      role: "Salesforce Developer/Architect",
      location: "Boston, MA",
      respo:false,
      duties:[
        "As a Salesforce developer/architect you will be building and maintaining applications on Client Salesforce org.",
        "The client's Department of Transportation currently uses Salesforce as a key application platform for various Client divisions.",
        "We are looking to expand the power of Salesforce and develop new apps for our business units at the Client.",
        "You will be challenged by a wide variety of projects including legacy database transformation, new custom apps, and more.",
        "We are seeking someone with excellent technical and communication skills who can interface directly with internal stakeholders, understand their needs, configure, and customize the platform to meet new/changing business requirements.",
        "This position will be responsible for ensuring that we are maximizing efficiency and capitalizing on all the features and benefits of the system based on various business needs.",
        "This position will promote adoption, keep current on new releases and AppExchange solutions, and act as the primary contact and a subject matter expert on complex and/or critical system issues and processes for the Client's Salesforce environment.",
      ],
      quali:false,

  },
    {
      id: 2,
      role: "Salesforce Administrator",
      location: "Englewood, CO",
      respo:"As a Salesforce Administrator, this individual will work with different internal teams and external vendors to provide the highest standards of Administration & Support Salesforce Applications.",
      duties:[
        "Provide technical knowledge in the design, development, implementation/installation, maintenance, and support of Salesforce application.",
        "Troubleshoot & resolve issues with infrastructure and application.",
        "Provide 24/7 application support as part of a rotating on-call schedule.",
      ],
      quali:[
        "3+ years of Salesforce development and/or administration experience",
        "Knowledge on Web service development and integration",
        "Foundational experience with multiple Salesforce cloud solutions primarily focused      on Sales and Service Cloud",
        "Experience with Lightning web components",
        "Active Salesforce certifications (PDI/PDII) will be a plus",
        "Experience with Salesforce DX and automated deployment processes",
        "Experience with databases and SQL fundamentals",
        "Willingness to learn and work on different AWS and on-prem applications",
      ],
  },
    {
      id: 3,
      role: "Salesforce Developer/Architect",
      location: "Boston, MA",
      duties:[
        "Serve as primary System architect and developer for the Salesforce environments",
        "Hands on configuration and development in addition to providing architectural oversight",
        "Provide solutions to business requests and design required architecture",
        "Handle administrative functions including user account maintenance, reports and dashboards, workflows, and other routine tasks",
        "Respond to end user issues, enhancement requests and other administrative needs",
        "Coordinate the evaluation, scope, and completion of new development requests",
        "Manage existing and new integration of applications to Salesforce",
        "Work independently with members of the user community to define and document development requirements",
        "Effectively act as the liaison between our users and application development team",
        "Complete regular internal system audits and prepare for upgrades",
        "Work with line of business partners to establish suitable processes to support development and change management activities",
        "Assist in training of new users, and grow the Salesforce skill set and adoption across the organization",
        "Design and build high-performance, reusable, and reliable Apex code with best practices",
        "Write test classes for the class that you develop and ensure more than 80% code coverage",
        "Test bug fixes to make sure they work as per requirements, then deploy them to production",
        "Take ownership of project work and developing client relationships",
        
      ],

    },
    {
      id: 4,
      role: "Sr JAVA FULL STACK DEVELOPER",
      location: "Remote",
      quali:
        ["Strong Java Full Stack Developer with 8+ years of experience in Java 1.8 ,Spring Core , Spring Boot, JQuery, Java script. Experience with Spring, Spring MVC, Hibernate, web services – REST/SOAP, JMS, JPA, MDB, CXF, SLF4J,c and other Java frameworks / open source libraries."],
      duties:[
        "Understanding of design patterns and NTier architectures", 
        "Experience in handling JSON, XML types. Good understanding in Data binding frameworks such as JAXB, Jackson and etc", 
        "Expertize in Kafka and knowledge in NoSQL da 3.Experience 8to10Yrs 4.Required Skills ,J2EE,Java 5.Nice to have skills ,Spring Boot 6.Technology -Not Applicable 7.Shift Day 9AM - 7PM EST 8.Roles & Responsibilities",
        "Strong Java Full Stack Developer with 5+ years of experience in Java 1.8 ,Spring Core , Spring Boot, JQuery, Java script. Experience with Spring, Spring MVC, Hibernate, web",
        
      ],
    },
  ];
  export default initialDetails;